import {
  DELETE_CUSTOMER_SUPERADMIN,
  DELETE_CUSTOMER_SUPERADMIN_FAILURE,
  DELETE_CUSTOMER_SUPERADMIN_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const deleteCustomerSuperAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_CUSTOMER_SUPERADMIN:
      return { ...state, loading: true };
    case DELETE_CUSTOMER_SUPERADMIN_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case DELETE_CUSTOMER_SUPERADMIN_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default deleteCustomerSuperAdminReducer;
